/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/generator/util',[], function() {
    'use strict';

    var util = {};

    /**
     * to shrint the image to 2/3 of it's size
     * @param  {Object} image Object containting datauri, width, height if image
     * @return {undefined}
     */
    util.shrinkImage = function(image) {
        image.width = (image.width);
        image.height = (image.height);
    };

    return util;
});
